// @ts-check

import ToolCall, { ToolCallState } from "@/components/tool-call"
import { ChatBubbleMessageCitationsContext, ChatMarkdown } from "../ChatBubble"
import z from "zod"

import { Globe } from "lucide-react"

const WebSearchArgsSchema = z.object({
  query: z.string(),
})

const WebSearchResultSchema = z.object({
  content: z.string(),
  citations: z.array(z.object({
    title: z.string(),
    url: z.string(),
  })).nullable(),
  images: z.array(z.object({
    title: z.string(),
    link: z.string(),
    source: z.string(),
    position: z.number(),
    original: z.string(),
    thumbnail: z.string(),
  })).nullable().optional()
})

/**
 * @param {import(".").ToolComponentProps<typeof WebSearchArgsSchema, typeof WebSearchResultSchema>} props
 */
function WebSearchToolUI({ args, result, state }) {
  const output = (() => {
    if(result == null) return null
    if(result instanceof Error) return result.message
    return result.content
  })()

  return (
    <ToolCall state={state}>
      <ToolCall.Header>
        <Globe size={16} className="flex-shrink-0" />
        <ToolCall.Action>{state === ToolCallState.PENDING ? "Searching": "Searched"}</ToolCall.Action>
        <ToolCall.Input>{args.query}</ToolCall.Input>
      </ToolCall.Header>

      <ToolCall.Content>
        <ToolCall.Output>
          {state === ToolCall.State.SUCCESS ? (
            <div>
              <ChatBubbleMessageCitationsContext value={{citations: result.citations}}>
                <ChatMarkdown>{result.content}</ChatMarkdown>
              </ChatBubbleMessageCitationsContext>
            </div>
          ): output}
        </ToolCall.Output>
      </ToolCall.Content>
    </ToolCall>
  )
}

export {
  WebSearchArgsSchema,
  WebSearchResultSchema,
  WebSearchToolUI,
}
